// src/api/graphql/queries/loginQuery.ts

import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation SellerLogin($username: String!, $password: String!) {
    sellerLogin(username: $username, password: $password) {
      success
      token
      seller {
        # Only return minimal required fields
        seller_id
        is_seller
      }
      message
    }
  }
`;
